// src/foundation/color/scc.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
var scc = (_obj = {}, _define_property(_obj, "red100" /* Red100 */ , "#E8344E"), _define_property(_obj, "red75" /* Red75 */ , "#FF6C7A"), _define_property(_obj, "red50" /* Red50 */ , "#FF9EA9"), _define_property(_obj, "red25" /* Red25 */ , "#FFD0DA"), _define_property(_obj, "red15" /* Red15 */ , "#FFF1F4"), _define_property(_obj, "red10" /* Red10 */ , "#FFF6F8"), _define_property(_obj, "green120" /* Green120 */ , "#0E434A"), _define_property(_obj, "green100" /* Green100 */ , "#30725D"), _define_property(_obj, "green75" /* Green75 */ , "#57B094"), _define_property(_obj, "green10" /* Green10 */ , "#D6FAEF"), _obj);
export { scc };
